import React, {useEffect, useState} from 'react';
import Cards from "../../Components/Schedule/PaymentMethod/Cards";
import './index.scss';

import '../Schedule/index.scss'
import {useLocation, useNavigate} from "react-router-dom";
import {useUpdatePaymentMethodMutation} from "../../Store/Builder/techsbook.api";
import {setLoader} from "../../Store/Slice/techsbookSlice";
import showToast from "../../Global/Hooks/toast";
import {useDispatch, useSelector} from "react-redux";
import Button from "../../UI/Button";
import useGetJobs from "../../Global/Api/Jobs/getJobs.api";

const UpdatePayment = () => {
  const Jobs = useGetJobs({allList: false});
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [type, setType] = useState(false)
  const location = useLocation()
  const [updatePayment] = useUpdatePaymentMethodMutation();
  const payment = useSelector(
    (state) => state.rootReducer.scheduleSlice.sendData?.payment_method_id
  );
  const isButtonDisabled = !(payment?.id || !type);

  useEffect(() => {
    if (location?.state?.type === 'card') {
      setType(true)
    } else {
      setType(false)
    }
  }, [location])

  const handleSave = () => {
    dispatch(setLoader(true));
    let body
    if (type) {
      body = {
        payment_method_id: payment?.id,
        job_id: location?.state?.job_id,
        paymentId: location?.state?.payment_id
      }
    } else {
      body = {
        job_id: location?.state?.job_id,
        stripe_payment_method: 'affirm',
        paymentId: location?.state?.payment_id
      }
    }
    updatePayment(body).unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        Jobs.getById();
        showToast(res?.message, "success");
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message, "error");
      });
  }

  return (
    <div className="payment__change">
      <div className="payment__change-box">
        <p className="payment__change-title">
          Change payment method
        </p>
        <div className="payment__change-form">
          <div className="payment__change-cards">
            {/*TODO: ADD CARDS MAP, DEPENDS ON WHICH METHOD IS USED */}
            <Cards jobDatetime={location?.state?.job_datetime} type={type} setType={setType} withCredits={false}/>
          </div>
          <div className="payment__change-btns">
            <div className="payment__change-btn cancel" onClick={() => navigate(-1)}>Cancel</div>

            <div onClick={handleSave} className="payment__change-btn save">
              <Button
                text={'Save'}
                disabled={isButtonDisabled}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePayment;
